import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/admin',
    name: 'global.admin',
    component: async () => import('@/components/AdminMenu.vue'),
  },
  {
    path: '/admin/timebands',
    name: 'z.timebands',
    component: async () => import('@/components/shifttimeband/ShiftTimeBandDataTable.vue'),
    meta: { permission: 'manage_time_bands' },
  },
  {
    path: '/admin/tags',
    name: 'z.tags',
    component: async () => import('@/components/tags/TagDataTable.vue'),
    meta: { permission: 'manage_tags' },
  },
  {
    path: '/admin/events',
    name: 'z.events',
    component: async () => import('@/components/events/EventDataTable.vue'),
    meta: { permission: 'manage_events' },
  },
  {
    path: '/admin/reports/:id',
    name: 'z.view_report',
    component: async () => import('@/components/reports/ReportShow.vue'),
    props: true,
    meta: {
      permission: [
        'manage_reports',
        'access_reports',
      ],
    },
  },
  {
    path: '/admin/reports',
    name: 'z.reports',
    component: async () => import('@/components/reports/ReportDataTable.vue'),
    meta: {
      permission: [
        'manage_reports',
        'access_reports',
      ],
    },
  },
  {
    path: '/admin/dayoverseers',
    name: 'z.day_overseers',
    component: async () => import('@/components/dayoverseers/DayOverseerIndex.vue'),
    meta: {
      permission: 'manage_dayoverseers',
    },
  },
  {
    path: '/admin/settings',
    name: 'z.settings',
    component: async () => import('@/components/settings/SettingsAdmin.vue'),
    meta: { permission: 'manage_settings' },
  },
  {
    path: '/admin/shiftplans',
    name: 'z.shift_plans',
    component: async () => import('@/components/shiftplan/ShiftPlanIndex.vue'),
    meta: { permission: 'manage_shift_plans' },
  },
  {
    path: '/admin/usersimport',
    name: 'z.import_users',
    component: async () => import('@/components/users/UserImport.vue'),
    meta: { permission: 'import_users' },
  },
  {
    path: '/admin/training/attendees/:id',
    name: 'course.course_attendees',
    component: async () => import('@/components/coursesessions/CourseSessionAttendees.vue'),
    props: true,
    meta: { permission: 'manage_course_sessions' },
  },
  {
    path: '/admin/experiences',
    name: 'z.experiences',
    component: async () => import('@/components/experiences/ExperienceAdmin.vue'),
    meta: { permission: 'manage_experiences' },
  },
  {
    path: '/admin/updates',
    name: 'z.update',
    component: async () => import('@/components/updates/UpdateManager.vue'),
    meta: { permission: 'update_application' },
  },
  {
    path: '/admin/report-issue',
    name: 'z.report_issue',
    component: async () => import('@/components/ReportIssue.vue'),
  },
  {
    path: '/admin/news',
    name: 'z.news',
    component: async () => import('@/components/news/NewsDataTable.vue'),
    meta: { permission: 'manage_news' },
  },
  {
    path: '/admin/teams',
    name: 'z.teams',
    component: async () => import('@/components/teams/TeamDataTable.vue'),
    meta: {
      permission: [
        'manage_teams',
      ],
    },
  },
  {
    path: '/admin/locations',
    name: 'z.locations',
    component: async () => import('@/components/locations/LocationIndex.vue'),
    meta: { permission: 'manage_locations' },
  },
  {
    path: '/visitingmap',
    name: 'z.visiting_map',
    component: async () => import('@/components/locations/VisitingMap.vue'),
    meta: { permission: 'access_visiting_map' },
  },
  {
    path: '/admin/locationmarkertypes',
    name: 'z.locationmarkertypes',
    component: async () => import('@/components/locations/LocationMarkerTypeDataTable.vue'),
    meta: { permission: 'manage_location_marker_types' },
  },
  {
    path: '/admin/faqs',
    name: 'z.faqs',
    component: async () => import('@/components/faqs/FaqAdmin.vue'),
    meta: { permission: 'manage_faqs' },
  },
  {
    path: '/admin/training',
    name: 'z.training',
    component: async () => import('@/components/TrainingIndex.vue'),
    meta: {
      permission: [
        'manage_courses',
        'manage_course_sessions',
      ],
    },
  },
  {
    path: '/admin/sysinfo',
    name: 'z.system_info',
    component: async () => import('@/components/SysInfo.vue'),
    meta: { permission: 'access_system_monitor' },
  },
  {
    path: '/admin/news/:id',
    name: 'z.view_article',
    component: async () => import('@/components/news/NewsPreview.vue'),
    props: true,
    meta: { permission: 'manage_news' },
  },
  {
    path: '/admin/documents',
    name: 'z.documents',
    component: async () => import('@/components/documents/DocumentDataTable.vue'),
    meta: { permission: 'manage_documents' },
  },
  {
    path: '/admin/circuits',
    name: 'z.circuits',
    component: async () => import('@/components/circuits/CircuitDataTable.vue'),
    meta: { permission: 'manage_circuits' },
  },
  {
    path: '/admin/api-keys',
    name: 'z.api_keys',
    component: async () => import('@/components/api-keys/ApiKeyDataTable.vue'),
    meta: { permission: 'manage_api_keys' },
  },
  {
    path: '/admin/mcp',
    name: 'z.mcp',
    component: async () => import('@/components/mcp/McpAdmin.vue'),
    meta: { permission: 'manage_mcp' },
  },
  {
    path: '/admin/congregations',
    name: 'z.congregations',
    component: async () => import('@/components/congregations/CongregationIndex.vue'),
    meta: {
      permission: [
        'manage_congregations',
        'manage_circuit_congregations',
      ],
    },
  },
  {
    path: '/admin/stores',
    name: 'z.stores',
    component: async () => import('@/components/stores/StoreIndex.vue'),
    meta: { permission: 'manage_stores' },
  },
  {
    path: '/admin/shifttags',
    name: 'z.shift_tags',
    component: async () => import('@/components/shifttags/ShiftTagDataTable.vue'),
    meta: { permission: 'manage_shift_tags' },
  },
  {
    path: '/admin/googleaccounts',
    name: 'z.google_accounts',
    component: async () => import('@/components/googleaccount/GoogleAccountDataTable.vue'),
  },
  {
    path: '/admin/shiftcancellationreasons',
    name: 'z.cancellation_reasons',
    component: async () => import('@/components/shiftcancellationreasons/ShiftCancellationReasonsDataTable.vue'),
    meta: { permission: 'manage_shift_cancellation_reasons' },
  },
  {
    path: '/admin/taskcategories',
    name: 'z.task_categories',
    component: async () => import('@/components/taskcategories/TaskCategoryDataTable.vue'),
    meta: {
      permission: ['manage_task_categories'],
    },
  },
  {
    path: '/admin/videos',
    name: 'z.videos',
    component: async () => import('@/components/videos/VideoDataTable.vue'),
    meta: { permission: 'manage_videos' },
  },
  {
    path: '/admin/userratinglabels',
    name: 'z.user_rating_labels',
    component: async () => import('@/components/userratinglabels/UserRatingLabelDataTable.vue'),
    meta: {
      permission: [
        'manage_users',
        'manage_shifts',
        'manage_user_ratings',
        'manage_user_rating_labels',
      ],
    },
  },
  {
    path: '/admin/languages',
    name: 'z.languages',
    component: async () => import('@/components/languages/LanguageDataTable.vue'),
    meta: { permission: 'manage_languages' },
  },
  {
    path: '/admin/contactmessageoptions',
    name: 'z.contact_options',
    component: async () => import('@/components/contactmessageoptions/ContactMessageOptionDataTable.vue'),
    meta: {
      permission: 'manage_contact_message_options',
    },
  },
  {
    path: '/admin/carts',
    name: 'z.carts',
    component: async () => import('@/components/carts/CartDataTable.vue'),
    meta: { permission: 'manage_cart' },
  },
  {
    path: '/admin/alertmessages',
    name: 'z.alerts',
    component: async () => import('@/components/alertmessages/AlertMessageDataTable.vue'),
    meta: { permission: 'manage_alert_messages' },
  },
  {
    path: '/admin/publications',
    name: 'z.publications',
    component: async () => import('@/components/publications/PublicationDataTable.vue'),
    meta: { permission: 'manage_publications' },
  },
  {
    path: '/admin/roles',
    name: 'z.roles_and_permissions',
    component: async () => import('@/components/roles/RoleDataTable.vue'),
    meta: { permission: 'manage_roles' },
  },
  {
    path: '/admin/shifts/schedule',
    name: 'z.schedule',
    component: async () => import('@/components/scheduler/ShiftScheduler.vue'),
    meta: {
      permission: [
        'manage_shifts',
        'view_all_shifts',
      ],
    },
  },
  {
    path: '/admin/users',
    name: 'z.users',
    component: async () => import('@/components/users/UserIndex.vue'),
    meta: {
      permission: [
        'manage_users',
        'manage_circuit_users',
        'view_user_details',
      ],
    },
  },
  {
    path: '/admin/users/:id',
    name: 'z.view_user',
    component: async () => import('@/components/users/UserShow.vue'),
    props: route => ({
      id: Number(route.params.id),
    }),
    meta: {
      permission: [
        'manage_users',
        'manage_circuit_users',
      ],
    },
  },
  {
    path: '/admin/users/:id/edit',
    component: async () => import('@/components/users/UserEditionFormWrapper.vue'),
    name: 'z.edit_user',
    props: (route) => ({ modelId: route.params.id, mode: 'edit' }),
  },
];

export default routes;
